// extracted by mini-css-extract-plugin
export var description = "styles-module--description--e69c2";
export var left = "styles-module--left--c7d7c";
export var right = "styles-module--right--0b621";
export var title = "styles-module--title--8bdce";